import i18n from '../../language/index'
import {
  create_data,
  create_header
} from '@/test/data'

import {
  create_mb_header_data
} from '@/base/mb_header_data'
import floatingFrameStyle from "@/widgets/basic_floating_frame/style.js"
import contactUsStyle from '@/view/contact_us/style.js'

const myRender = {
  namespaced: true,
  state: {

    header: [], //头部（数据源）
    body: [], //身体（数据源）
    footer: [], //底部（数据源）
    full_screen_banner: [], //横幅

    private: {
      //页面横幅类型，private：私有  share:共享
      banner_type: 'private',

      banner_isShow: true,

      //背景固定是否开启
      fixed_background_isOpen: 'false',

      //H1组件开关
      H1_isOpen: false,

      isFullPage: false,

      // 全屏滚动的顶部类型
      fullPageTopNavType: 'xuanfu',

      // 全屏滚动的样式类型（右边导航）
      fullPageStyleType: '0',

      // 全屏滚动页脚类型
      fullPageFooterType: 'type0',

      // 浮框是否显示
      floatingFrameOpen: false,
      floatingFrameStyle: {
        data: floatingFrameStyle,
        name: 'basic_floating_frame'
      }
    },

    //放置公共组件和公共属性
    common: {
      // vip标签显示方式
      vip_type: 'default',  // default custom
      vip_type_footer: 'default', // default custom
      //主题色
      theme_color: 'rgba(239,65,54,1)',
      theme_color_type: 'default_1', // 主题色类型

      // 预览模式
      previewModule: 'this',

      // 是否显示顶部
      header_display: 'true',
      //是否显示底部
      footer_display: 'true',
      //主题背景
      body_background: {
        radio_val: 'default',
        default: {
          type: 'color', // 背景设置-类型
          img: '', // 背景设置-图片的URL
          color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
          img_scale: 'scale_tiling', //图片缩放 填充、等比例、平铺、拉伸、原图
          tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
          background_size: 'cover',
          background_repeat: 'no-repeat',
          background_position: 'center center' //图片位置
        },
        custom: {
          type: 'color', // 背景设置-类型
          img: '', // 背景设置-图片的URL
          color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
          img_scale: 'scale_tiling', //图片缩放 填充、等比例、平铺、拉伸、原图
          tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
          background_size: 'cover',
          background_repeat: 'no-repeat',
          background_position: 'center center' //图片位置
        }
      },

      //顶部背景
      header_background: {
        radio_val: 'default',
        default: {
          type: 'color', // 背景设置-类型
          img: '', // 背景设置-图片的URL
          color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
          img_scale: 'scale_tiling', //图片缩放 填充、等比例、平铺、拉伸、原图
          tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
          background_size: 'cover',
          background_repeat: 'no-repeat',
          background_position: 'center center' //图片位置
        },
        custom: {
          type: 'color', // 背景设置-类型
          img: '', // 背景设置-图片的URL
          color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
          img_scale: 'scale_tiling', //图片缩放 填充、等比例、平铺、拉伸、原图
          tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
          background_size: 'cover',
          background_repeat: 'no-repeat',
          background_position: 'center center' //图片位置
        }
      },

      //底部背景
      footer_background: {
        radio_val: 'default',
        default: {
          type: 'color', // 背景设置-类型
          img: '', // 背景设置-图片的URL
          color: 'rgba(255, 255, 255, 1)', // 背景设置-颜色
          img_scale: 'scale_tiling', //图片缩放 填充、等比例、平铺、拉伸、原图
          tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
          background_size: 'cover',
          background_repeat: 'no-repeat',
          background_position: 'center center' //图片位置
        },
        custom: {
          type: 'color', // 背景设置-类型
          img: '', // 背景设置-图片的URL
          color: 'rgba(255, 255, 255, 1)', // 背景设置-颜色
          img_scale: 'scale_tiling', //图片缩放 填充、等比例、平铺、拉伸、原图
          tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
          background_size: 'cover',
          background_repeat: 'no-repeat',
          background_position: 'center center' //图片位置
        }
      },

      //共享横幅
      full_screen_banner: [], //横幅

      createrMessage: {
        createrShow: 'true',
        loginShow: 'true',
      },

      //固定顶部
      fixed_header: 'true',

      //固定高度
      fixed_height: 'all', //all:整个顶部 system：导航所在系统栏目

      //固定背景
      fixed_background: {
        radio_val: 'default',
        default: {
          type: 'color', // 背景设置-类型
          img: '', // 背景设置-图片的URL
          color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
          img_scale: 'scale_tiling', //图片缩放 填充、等比例、平铺、拉伸、原图
          tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
          background_size: 'cover',
          background_repeat: 'no-repeat',
          background_position: 'center center' //图片位置
        },
        custom: {
          type: 'color', // 背景设置-类型
          img: '', // 背景设置-图片的URL
          color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
          img_scale: 'scale_tiling', //图片缩放 填充、等比例、平铺、拉伸、原图
          tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
          background_size: 'cover',
          background_repeat: 'no-repeat',
          background_position: 'center center' //图片位置
        }
      },

      //返回顶部按钮
      fixed_back_top: {
        button_style: 'default',
        show_back_top: true,
        pcShowBtn: false,
        mbShowBtn: false,
        button_color: {
          radio_val: 'default',
          default: {
            id: 'default-0',
            borderRadius: '50%',
            canChangeColor: true,
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
            iconName: 'el-icon-arrow-up',
            color: '#fff'
          },
          custom: {
            url: 'https://preapiconsole.71360.com/file/read/www/M00/01/60/wKgBbF5F-HSAaMfQAAArKq7c-fY663.jpg'
          }
        },
        customColor: 'rgba(0, 0, 0, 0.1)'
      },

      contact_us: { // contact_us 联系我们新加的数据
        contact_us_show: false,
        contact_us_set: contactUsStyle.contact_us_set,
        listArr: contactUsStyle.listArr
      },

      // 网站设置
      setting: {
        title: i18n.t('vuex_modules_render_316'),
        logoTitleRadio: true,
        headerNavRadio: true,
        returnTopRadio: true,
        // 语言导航开关
        multiLanguageOpen: false,
        // 语言设置（中文站）
        zhLanguageOpen: false,
        //中文站设置的切换地址
        zhLanguageAdress: '',
        // 底部服务栏开关
        footnavOpen: false,
        headerSearchOpen: false,
        loginRegister: false, // 头部登录注册是否开启
        shoppingCart: false,  // 购物车
      },

      //移动端顶部背景颜色
      mb_header_background: create_mb_header_data().mb_header_background,

      //移动端顶部导航颜色
      mb_header_btn_background: create_mb_header_data().mb_header_btn_background,

      // 产品详情咨询展示
      displayContactRadio: 'block',
      // 导航位置
      mb_header_nav_position: 'left',
      // 网站标题
      mb_header_nav_title: {
        radio_val: 'default',
        default: {
          fontSize: 18
        },
        custom: {
          fontSize: 18
        }
      },
      // ICP备案信息
      icp_isShow: 'true',
      adaptWidth: {
        isOpen: 'false',
        radioVal: 1200,
        val: 1200,
        customVal: 1440
      },
      header_layout_row_setting: 'zhanwei', // zhanwei 占位 xuanfu 悬浮
      xuanfu_position: 'index', // index 首页 station 全站
      visitor_auth: 'show'  // 访客授权
    },
  },
  mutations: {
    SET_header(state, data) {
      state.header = data;
    },
    SET_body(state, data) {
      state.body = data;
    },
    SET_footer(state, data) {
      state.footer = data;
    },
    SET_full_screen_banner(state, data) {
      state.full_screen_banner = data;
    },
    SET_common_banner(state, data) {
      state.common.full_screen_banner = data;
    },
    test_data(state, data) {
      state.body = create_data('body');
      state.footer = create_data('footer');
      state.header = create_header('header');
      if ($('.init_mongolia_layer').length > 0) {
        $('.init_mongolia_layer').remove();
      }
      if ($('.login_dialog_warp').length > 0) {
        $('.login_dialog_warp').remove();
      }
    },
    set_banner_type(state, val) {
      state.private.banner_type = val;
    },
    set_theme_color(state, val) {
      state.common.theme_color = val;
    },
    set_copyright(state, val) {
      state.common.copyright = val
    },
    set_common(state, val) {
      state.common = val
    },
    set_private(state, val) {
      state.private = val
    },
    //渲染重置
    render_reset(state) {
      state.header = [];
      state.body = [];
      state.footer = [];
      state.full_screen_banner = [];
      state.common.full_screen_banner = [];
      state.private = {
        banner_type: 'private',
        banner_isShow: true
      }
    },
    // 是否显示顶部
    set_header_display(state, val) {
      state.common.header_display = val
    },
    // 是否显示底部
    set_footer_display(state, val) {
      state.common.footer_display = val
    },
    SET_header(state, data) {
      state.header = data;
    },
    SET_show_back_top(state, bl) {
      state.common.fixed_back_top.show_back_top = bl
      state.common.setting.returnTopRadio = bl
    },
    SET_footnavOpen(state, val) {
      state.common.setting.footnavOpen = val
    },
    SET_theme_color_type(state, val) {
      state.common.theme_color_type = val
    },
    setFullPageStyleType(state, val) {
      state.private.fullPageStyleType = val
    },
    setFullPageTopNavType(state, val) {
      state.private.fullPageTopNavType = val
    },
    setFullPageFooterType(state, val) {
      state.private.fullPageFooterType = val
    },
    setFullPageMode(state, val) {
      console.log(state)
      state.private.isFullPage = val
    },
    set_floating_frame_open(state, val) {
      state.private.floatingFrameOpen = val
    },
    SET_show_login_register(state, val) {
      state.common.setting.loginRegister = val
    },
    set_contact_us_set_default(state, val) { // contact_us 联系我们设置 系统或者是 默认的
      state.common.contact_us.contact_us_set.default = val
    },
    set_contact_us_set_default_bg(state, val) {
      state.common.contact_us.contact_us_set.default.backgroundColor = val
    },
    set_contact_us_set_custom_url(state, val) { // contact_us  联系 我们设置自定义设置图片
      state.common.contact_us.contact_us_set.customSet.url = val
    },
    set_contact_us_show(state, val) { // contact_us联系 我们是否显示
      state.common.contact_us.contact_us_show = val
    },
    SET_HEADER_SEARCH(state, val) {
      state.common.setting.headerSearchOpen = val
    },
  },
  actions: {}
};

//测试用


export default myRender;



// WEBPACK FOOTER //
// ./src/vuex/modules/render.js